export default class CarouselGallery {

    constructor() {

        let carousel = document.getElementById('carouselGallery');

        // is the element present on the current page
        if (!carousel) {
            return;
        }

        let thumbnails = document.querySelector('.contest-gallery__thumbnails');
        let item = document.querySelector('.contest-gallery__thumbnail');
        // on carousel scroll, scroll the bottom with thumbnails appropriately, but slowly

        $('#carouselGallery').on('slide.bs.carousel', event => {
            if ($(document).width() > 991) {
                thumbnails.scrollLeft = (event.to - 2) * item.offsetWidth;
            } else {
                thumbnails.scrollLeft = (event.to - 1.5) * item.offsetWidth;
            }
        })

        $('.contest-gallery__thumbnail').on('click', function(event) {
            $('#carouselGallery').carousel(parseInt($(this).attr("data-id")));
        });
    }
}